import {common_utils} from "../common/common_utils";

function game_3001()
{

}


game_3001.getWinInfo = function(obj)
{
  let winInfo = "";
  if(common_utils.isNull(obj))
  {
    return winInfo;
  }
  let TotalBet = 0;
  let TotalWin = 0;
  let Odds  = 0;
  if(obj.TotalBet)
  {
    TotalBet = obj.TotalBet;
  }
  if(obj.TotalWin)
  {
    TotalWin = obj.TotalWin;
  }
  if(obj.Odds){
    Odds = obj.Odds;
  }
  if(TotalWin <= 0)
  {
    Odds = 0;
  }
  winInfo += "("+(TotalBet / 100).toFixed(2)+" x " +Odds+")"+" - " +(TotalBet / 100).toFixed(2);
  winInfo += " = " +(TotalWin / 100).toFixed(2)+" - " +(TotalBet / 100).toFixed(2);
  winInfo += " = " +((TotalWin-TotalBet) / 100).toFixed(2);
  return winInfo;
}

export {
  game_3001
};



// WEBPACK FOOTER //
// ./src/components/esports/game_3001.js